export default __webpack_public_path__ + "static/media/grading-confusion-matrix-status.062bb1fc.png";